import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Select } from "@libs/rubick";
import { FILTER_VALUES } from "@/constants/filters";
import { SHARED_TIME_RANGE_OPTIONS } from "@/constants/timeRange";
import useAuthStore from "@/context/auth/useAuthStore";
import { useApiKeys } from "@/hooks/api-keys";
export function AuditLogsFilters({ filters, onTimeRangeChange, onApiKeyChange, productCode: productCodeProp }) {
    const { productCode: authProductCode } = useAuthStore();
    const productCode = productCodeProp ?? authProductCode;
    const { data: apiKeysData, isLoading } = useApiKeys(productCode || "", productCode !== undefined);
    return /*#__PURE__*/ _jsx(Card, {
        variant: "bordered",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 gap-4 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "Date Range"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "inline-flex rounded-lg bg-gray-100 p-1",
                            children: SHARED_TIME_RANGE_OPTIONS.map((option)=>/*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>onTimeRangeChange(option.value),
                                    className: `rounded-md px-3 py-1.5 text-sm transition ${filters.timeRange === option.value ? "bg-navy-70 text-white font-medium" : "text-gray-600 hover:bg-gray-200"}`,
                                    children: option.label
                                }, option.value))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            htmlFor: "apiKey",
                            className: "block text-sm font-medium text-gray-700 mb-2",
                            children: "API Key"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "relative",
                            children: /*#__PURE__*/ _jsxs(Select, {
                                id: "apiKey",
                                value: filters.selectedApiKey,
                                onChange: (e)=>onApiKeyChange(e.target.value),
                                disabled: isLoading || !apiKeysData?.items?.length,
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        value: FILTER_VALUES.ALL,
                                        children: isLoading ? "Loading API Keys..." : "All API Keys"
                                    }),
                                    apiKeysData?.items?.map((apiKey)=>/*#__PURE__*/ _jsx("option", {
                                            value: apiKey.id,
                                            children: apiKey.name ? `${apiKey.name} (${apiKey.id.slice(0, 8)}...)` : apiKey.id
                                        }, apiKey.id))
                                ]
                            })
                        }),
                        apiKeysData?.items && /*#__PURE__*/ _jsxs("p", {
                            className: "mt-1.5 text-xs text-gray-500 pl-1",
                            children: [
                                apiKeysData.items.length,
                                " API key",
                                apiKeysData.items.length !== 1 ? "s" : "",
                                " available"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
